import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Alert, AlertTitle, Box, Button } from "@mui/material";

import { formConfigSecondStep } from "../form-config";
import { useGetUsersByPasswordMutation, useLazyGetProfileInfoQuery } from "../../../../middleware/usersApi";
import { useAppSelector } from "../../../../hooks/redux";
import { PATHS } from "../../../../constants";

import ProfileItemView from "../../../components/ProfileItemView";
import FormItem from "../../../components/FormItem";
import { useAction } from "../../../../hooks/actions";

const SecondStep = ({ setAuthStep }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [getUserByPassword] = useGetUsersByPasswordMutation();
  const [getProfileInfo] = useLazyGetProfileInfoQuery();
  const { setIsBlockedOrganizations } = useAction();
  const { login, firstName, lastName, isActive, isOrganizationBlocked } = useAppSelector((state) => state.users.info);

  const {
    control,
    setError,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });

  useEffect(() => {
    if (isOrganizationBlocked) {
      setIsBlockedOrganizations(isOrganizationBlocked);
      navigate(PATHS.CABINET);
    }
  }, [isOrganizationBlocked]);

  const onSubmit = async (data) => {
    const response = await getUserByPassword({ ...data, login });
    if (response.error?.status === 404) {
      setError("password", { type: "custom", message: "incorrect_password" });
      return;
    }
    getProfileInfo(response.data.userToken);
    // Код ниже не работает. Скорее всего больше не нужен. Пережитки прошлого
    // if (response.isActive) {
    //   navigate(PATHS.MY_ORGANIZATIONS);
    // }
  };

  return (
    <Box>
      <ProfileItemView />
      {isOrganizationBlocked ? (
        <Alert severity="error">
          <AlertTitle>{t("label:organizationBlocked")}</AlertTitle>
        </Alert>
      ) : isActive ? (
        <form id="loginForm" className="object-form" onSubmit={handleSubmit(onSubmit)}>
          {formConfigSecondStep.map(({ name, label, input, ...rest }) => (
            <FormItem key={name} control={control} errors={errors} name={name} label={label} input={input} {...rest} />
          ))}
          <Button
            sx={{ m: "24px 0", height: "52px" }}
            fullWidth
            className="btn btn-primary-fill"
            type="submit"
          >
            {t("button:login")}
          </Button>
        </form>
      ) : (
        <Alert severity="error">
          <AlertTitle>
            {t("label:accountBlocked", {
              userName: `${firstName} ${lastName}`,
            })}
          </AlertTitle>
          {t("label:supportRequest")}
        </Alert>
      )}
    </Box>
  );
};

export default SecondStep;
